import { makeVar, TypePolicies } from '@apollo/client';
import { NOT_DISPLAY_POPUP } from './VisibilityDisplayPopup.constants';

export const typePolicies: TypePolicies = {
  Query: {
    fields: {
      isGlobalLoading: {
        read() {
          return isGlobalLoadingVar();
        },
      },
      displayVisibility: {
        read() {
          return displayVisibility();
        },
      },
      selectedEnvName: {
        read() {
          return selectedEnvNameVar();
        },
      },
    },
  },
};

export const displayVisibility = makeVar<number>(NOT_DISPLAY_POPUP);
export const isGlobalLoadingVar = makeVar<boolean>(false);
export const selectedEnvNameVar = makeVar<string | undefined>(undefined);
